import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {
  Box,
  CloseButton,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Text,
} from '@chakra-ui/react'

import PaymentPropType from '../../propTypes'
import DownloadMCoinFeeTaxInvoiceButton from './DownloadMCoinFeeTaxInvoiceButton'
import PaymentMethodSection from './PaymentMethodSection'
import PayeeDetailsSection from './PayeeDetailsSection'
import PaymentDetailsSection from './PaymentDetailsSection'
import SummarySection from './SummarySection'

const PaymentsDrawer = ({payment, isOpen, onClose}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Drawer isOpen={isOpen} placement="right" size="md" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderBottom="1px solid"
            borderColor="neutral.glitter"
          >
            <Text textStyle="body-intro-medium" fontSize="md">
              {t('pointsOnPayments:pointsOnPayment.drawer.title')}
            </Text>

            <CloseButton onClick={onClose} />
          </Box>
        </DrawerHeader>

        <DrawerBody overflowY="scroll" py="md">
          {payment && (
            <Flex direction="column" gap="md">
              <SummarySection payment={payment} />
              <Divider />
              <PayeeDetailsSection payee={payment.payee} />
              <Divider />
              <PaymentDetailsSection {...payment} />
              <Divider />
              <PaymentMethodSection paymentMethod={payment.paymentMethod} />
              {payment.mcoinFeeTaxInvoiceAvailable && (
                <>
                  <Divider />
                  <DownloadMCoinFeeTaxInvoiceButton paymentId={payment.id} />
                </>
              )}
            </Flex>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

PaymentsDrawer.defaultProps = {
  payment: null,
}

PaymentsDrawer.propTypes = {
  payment: PaymentPropType,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default PaymentsDrawer
